import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import requestConfig from 'app/requests/Quote/SimplifiedQuote.requests'

import {
    RequestFeesData,
} from '../SimplifiedCQuoteCreate/simplifiedCQuoteCreate.types'

const useGetFeesData = (requestData: RequestFeesData) => {
    return useRequest({
        key: RequestKeys.getSimplifiedQuoteFeesData,
        params: requestData,
        requestFunc: RequestFn.getEntity(requestConfig.getFeesData),
        enabled: Boolean(requestData),
    })
}

export default useGetFeesData
